import { useEffect, useState } from 'react'
import {
  getService29VehicleCerts,
  VehicleCert,
  VehicleCertQuery
} from '../../services/endpoints/service29'

const useCertList = (isActive: boolean, query: VehicleCertQuery) => {
  const [certs, setCerts] = useState<VehicleCert[]>([])
  const [total, setTotal] = useState(0)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if (!isActive) {
      setCerts([])
      setTotal(0)
      return
    }

    let cancelled = false

    getService29VehicleCerts(query)
      .then((res) => {
        if (!cancelled) {
          setCerts(res.data)
          setTotal(res.paging.total)
        }
      })
      .catch((err) => {
        if (!cancelled)
          setError(err?.message ?? 'Failed to load certificates')
      })

    return () => {
      cancelled = true
    }
  }, [query, isActive])

  return { certs, setCerts, total, error }
}

export default useCertList
